export const PaginationType = Object.freeze({
  Static: 'static',
  Dynamic: 'dynamic',
})
